import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  EDIT_PROFILE,
  EDIT_COMPANY,
  ADD_LOCATION,
  LOCATION_LIST,
  MANAGER_LIST,
  ASSIGN_LOCATION,
  GET_MANAGER_BY_ID,
  GET_EMPLOYEE_BY_LOCATION,
  UPDATE_MANAGER_DETAILS,
  DELETE_LOCATION,
  LOGIN_AS_MANAGER,
  LOGIN_AS_ADMIN,
  AVAILABLE_LOCATIONS,
  SKIP_LOCATION,
  GET_PARTICIPANT_BY_LOCATION,
  NOTIFICATION,
  FREE_NOTIFICATION,
  IS_USER_VALID,
  GET_USER_DATA,
  ADD_ADMIN_SWITCH_ACCOUNT,
} from "./actionTypes";

import {
  profileSuccess,
  profileError,
  addLocationSuccess,
  addLocationFail,
  getLocationsListSuccess,
  getLocationsListFail,
  getManagerListSuccess,
  getManagerListFail,
  assignLocationsSuccess,
  assignLocationsFail,
  getManagerDetailsSuccess,
  getManagerDetailsFail,
  getEmployeeByLocationSuccess,
  getEmployeeByLocationFail,
  updateManagerSuccess,
  updateManagerFail,
  deleteLocationSuccess,
  deleteLocationFail,
  loginAsManagerSuccess,
  loginAsManagerFail,
  LocationsListSuccess,
  LocationsListFail,
  skipLocationSuccess,
  skipLocationFail,
  getParticipantByLocationSuccess,
  getParticipantByLocationFail,
  getMyNotificatinsSuccess,
  getMyNotificatinsFail,
  freeNotificatinsSuccess,
  freeNotificatinsFail,
  getMyNotificatins,
  loginAsAdminFail,
  loginAsAdminSuccess,
  getUserDataSuccess,
  addAdminSwitchAccountSuccess,
  addAdminSwitchAccountFail,
} from "./actions";

import {
  postProfile,
  postJwtProfile,
  editCompanyProfile,
  addLocations,
  fetchLocationList,
  fetchManagerList,
  locationAssigning,
  fetchManagerDetails,
  fetchEmployeeByLocationList,
  updateManagerData,
  locationDelete,
  managerLogin,
  adminLogin,
  getAllLocations,
  locationSkip,
  fetchParticipantByLocationList,
  fetchNotifications,
  onFreeNotifications,
  checkUserValidity,
  getUserInfo,
  onAddingAdminSwitch,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { showNotifications } from "common/ApiCalls";
import { responseHandler } from "common/CommanFunction";

function removeAuth() {
  localStorage.removeItem("authUser");
  localStorage.removeItem("company_logo");
  localStorage.removeItem("timezone");
  localStorage.removeItem("pro_pic");
  localStorage.removeItem("uid");
}

function* onAddSwitchAccount({ payload: { data, onError, onSuccess } }) {
  try {
    const response = yield call(onAddingAdminSwitch, data);
    yield call(responseHandler, response, "Verify Account", addAdminSwitchAccountSuccess, addAdminSwitchAccountFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addAdminSwitchAccountFail(error));
    showToast("error", "Login", error);
  }
}

function* onGetUser({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(getUserInfo, data);
    if (!response?.status) {
      showToast("info", "Account Deactivated", "Your account is no longer accessible, Logging out...");
      setTimeout(() => {
        removeAuth();
        window.location.href = "/login";
      }, 1000 * 5);
    }
    localStorage.setItem("authUser", JSON.stringify(response));
    yield put(getUserDataSuccess(data));
    yield call(responseHandler, "User", response, getUserDataSuccess, getUserDataSuccess, onSuccess, onError, false, false);
  } catch (error) {
    showToast("error", "User", error);
    onError();
    if (error?.includes("Unauthorized")) {
      removeAuth();
      // window.location.href = '/login';
    }
    console.log(error);
  }
}

function* onLoginOtherRole({ payload: { data, history } }) {
  try {
    // const user_token = me()?.user_token;
    const response = yield call(managerLogin, data);
    if (response.status) {
      const data = {
        ...response,
        uid: response.client_id,
        username: response?.client_name,
        role: response?.admin_type,
        email: response?.client_email,
        regis_no: response?.registration_number,
        com_name: response?.company_name,
        manager_uid: response?.manager_id ? response?.manager_id : "",
        verification_email: response?.verification_email ? response?.verification_email : "",
        // user_token,
      };
      yield put(getUserDataSuccess(data));
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(response?.time_zone));
      if (response?.profile_pic_path) localStorage.setItem("pro_pic", JSON.stringify(response?.profile_pic_path));
      if (response?.company_logo) localStorage.setItem("company_logo", JSON.stringify(response?.company_logo));
      localStorage.setItem("fastLogin", "true");
      // localStorage.setItem("user_token", user_token)
      showToast("success", "Authentication", "Successfully login");
      yield put(loginAsManagerSuccess(response));
      // history.push('/dashboard');
      window.location.href = "/dashboard";
    }
  } catch (error) {
    yield put(loginAsManagerFail(error));
    showToast("error", "Authentication", error);
  }
}

function* Login_As_Admin({ payload: { data, history } }) {
  try {
    const response = yield call(adminLogin, data);
    if (response.status && response.admin_type == "admin") {
      const data = {
        ...response,
        uid: response?.client_id,
        username: response?.client_name,
        role: response?.admin_type,
        email: response?.client_email,
        regis_no: response?.registration_number,
        com_name: response?.company_name,
        manager_uid: response?.manager_id ? response?.manager_id : "",
        verification_email: response?.verification_email ? response?.verification_email : "",
        // user_token: me()?.user_token,
      };
      yield put(getUserDataSuccess(data));
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(response?.time_zone));
      localStorage.setItem("pro_pic", JSON.stringify(response?.profile_pic_path));
      localStorage.setItem("company_logo", JSON.stringify(response?.company_logo));
      localStorage.removeItem("fastLogin");
      // localStorage.removeItem("user_token")
      showToast("success", "Authentication", "Successfully login");
      yield put(loginAsAdminSuccess(response));
      // history.push("/dashboard")
      window.location.href = "/dashboard";
    }
  } catch (error) {
    yield put(loginAsAdminFail(error));
    showToast("error", "Authentication", error);
  }
}

function* editProfile({ payload: user }) {
  try {
    const response = yield call(postProfile, user);
    yield put(profileSuccess(response));
    showToast("success", "Profile", response.message);
    localStorage.setItem("pro_pic", JSON.stringify(response.data.file_path));
  } catch (error) {
    yield put(profileError(error));
    showToast("error", "Profile", error);
  }
}

// not in use
function* checkIsUserValid({ payload: { data, history } }) {
  try {
    const response = yield call(checkUserValidity, data);
    if (!response?.status && (response?.message.includes("Not Exist") || response?.message.includes("Session expired"))) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("company_logo");
      localStorage.removeItem("timezone");
      localStorage.removeItem("pro_pic");
      showToast("info", "Account Deactivated", "Your account is no longer accessible, Logging out...");
      setTimeout(() => {
        history?.push("/login");
      }, 1000 * 5);
    }
  } catch (error) {
    yield put(profileError(error));
  }
}

function* editCompany({ payload: data }) {
  try {
    const response = yield call(editCompanyProfile, data);
    yield put(profileSuccess(response));
    showToast("success", "Company Profile", response.message);
    localStorage.setItem("company_logo", JSON.stringify(response?.company_logo));
  } catch (error) {
    yield put(profileError(error));
    showToast("error", "Company Profile", error);
  }
}

function* Delete_Location({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(locationDelete, data);
    yield call(responseHandler, "Disable Location", response, deleteLocationSuccess, deleteLocationSuccess, onSuccess, onError, true, false);
  } catch (error) {
    onError();
    yield put(deleteLocationFail(error));
    showToast("error", "Delete Location", error);
  }
}

function* Skip_location({ payload: data }) {
  try {
    const response = yield call(locationSkip, data);
    if (response.status) {
      yield put(skipLocationSuccess(response));
      showToast("success", "Location", response.message);
    } else {
      yield put(skipLocationSuccess(response));
      showToast("warning", "Location", response.message);
    }
  } catch (error) {
    yield put(skipLocationFail(error));
    showToast("error", "Location", error);
  }
}

function* Add_Locations({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(addLocations, data);
    yield call(responseHandler, "Add Location", response, addLocationSuccess, addLocationFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addLocationFail(error));
    showToast("error", "Locations", error);
  }
}

function* Update_Manager({ payload: data }) {
  try {
    const response = yield call(updateManagerData, data);
    yield put(updateManagerSuccess(response));
    showToast("success", "Manager", response.message);
  } catch (error) {
    yield put(updateManagerFail(error));
    showToast("error", "Manager", error);
  }
}

function* Assign_Locations({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(locationAssigning, data);
    yield call(responseHandler, "Assign Location", response, assignLocationsSuccess, assignLocationsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(assignLocationsFail(error));
    showToast("error", "Assigning Location", error);
  }
}

function* Manager_Details({ payload: data }) {
  try {
    const response = yield call(fetchManagerDetails, data);
    yield put(getManagerDetailsSuccess(response));
  } catch (error) {
    yield put(getManagerDetailsFail(error));
    showToast("error", "Manager Details", error);
  }
}

function* GetMyNotifications({ payload: data }) {
  try {
    const response = yield call(fetchNotifications, data);
    yield put(getMyNotificatinsSuccess(response));
  } catch (error) {
    yield put(getMyNotificatinsFail(error));
    showToast("error", "Notifications", error);
  }
}

function* FreeMyNotifications({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onFreeNotifications, data);
    yield put(freeNotificatinsSuccess(response));
    showNotifications(dispatch);
  } catch (error) {
    yield put(freeNotificatinsFail(error));
    showToast("error", "Notifications", error);
  }
}

function* Available_Locations_List({ payload: data }) {
  try {
    const response = yield call(getAllLocations, data);
    yield put(LocationsListSuccess(response));
  } catch (error) {
    yield put(LocationsListFail(error));
    showToast("error", "Fetch Locations List", error);
  }
}

function* Locations_List({ payload: data }) {
  try {
    const response = yield call(fetchLocationList, data);
    yield put(getLocationsListSuccess(response));
  } catch (error) {
    yield put(getLocationsListFail(error));
    showToast("error", "Fetch Locations List", error);
  }
}

function* Participant_By_Location({ payload: data }) {
  try {
    const response = yield call(fetchParticipantByLocationList, data);
    yield put(getParticipantByLocationSuccess(response));
  } catch (error) {
    yield put(getParticipantByLocationFail(error));
    showToast("error", "Fetch Participant List", error);
  }
}

function* Employee_By_Location({ payload: data }) {
  try {
    const response = yield call(fetchEmployeeByLocationList, data);
    yield put(getEmployeeByLocationSuccess(response));
  } catch (error) {
    yield put(getEmployeeByLocationFail(error));
    showToast("error", "Fetch Employee List", error);
  }
}

function* Manager_List({ payload: data }) {
  try {
    const response = yield call(fetchManagerList, data);
    yield put(getManagerListSuccess(response));
  } catch (error) {
    yield put(getManagerListFail(error));
    showToast("error", "Fetch Manager List", error);
  }
}

export function* watchProfile() {
  yield takeEvery(ADD_ADMIN_SWITCH_ACCOUNT, onAddSwitchAccount);
  yield takeEvery(GET_USER_DATA, onGetUser);
  yield takeEvery(EDIT_PROFILE, editProfile);
  yield takeEvery(EDIT_COMPANY, editCompany);
  yield takeEvery(ADD_LOCATION, Add_Locations);
  yield takeEvery(LOCATION_LIST, Locations_List);
  yield takeEvery(MANAGER_LIST, Manager_List);
  yield takeEvery(DELETE_LOCATION, Delete_Location);
  yield takeEvery(ASSIGN_LOCATION, Assign_Locations);
  yield takeEvery(GET_MANAGER_BY_ID, Manager_Details);
  yield takeEvery(UPDATE_MANAGER_DETAILS, Update_Manager);
  yield takeEvery(LOGIN_AS_MANAGER, onLoginOtherRole);
  yield takeEvery(SKIP_LOCATION, Skip_location);
  yield takeEvery(LOGIN_AS_ADMIN, Login_As_Admin);
  yield takeEvery(GET_EMPLOYEE_BY_LOCATION, Employee_By_Location);
  yield takeEvery(AVAILABLE_LOCATIONS, Available_Locations_List);
  yield takeEvery(GET_PARTICIPANT_BY_LOCATION, Participant_By_Location);
  yield takeEvery(NOTIFICATION, GetMyNotifications);
  yield takeEvery(FREE_NOTIFICATION, FreeMyNotifications);
  yield takeEvery(IS_USER_VALID, checkIsUserValid);
}

function* ProfileSaga() {
  yield all([fork(watchProfile)]);
}

export default ProfileSaga;
